var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetranscribeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "re-transcribeIcon",
    transform: "translate(-744 -266)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 40,
    height: 40,
    transform: "translate(744 266)",
    fill: "#24dac5",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M18.73,35.477H7.348A3.358,3.358,0,0,1,4,32.13V5.348A3.358,3.358,0,0,1,7.348,2H20.739L30.782,12.043V17.9a10.929,10.929,0,0,0-3.348-.837V13.717H19.065V5.348H7.348V32.13h9.206a14.358,14.358,0,0,0,2.176,3.348",
    transform: "translate(746.695 267.348)",
    fill: "#24dac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6022",
    "data-name": "Path 6022",
    d: "M3.327,1.83,6.654,0,4.824,3.327l1.83,3.327L3.327,4.824,0,6.654,1.83,3.327,0,0,3.327,1.83",
    transform: "translate(769.589 290.726) rotate(135)",
    fill: "#24dac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6023",
    "data-name": "Path 6023",
    d: "M4.99,0,3.576,2.5,4.99,4.99,2.5,3.576,0,4.99,1.414,2.5,0,0,2.5,1.414,4.99,0",
    transform: "translate(779.151 289.615) rotate(135)",
    fill: "#24dac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6024",
    "data-name": "Path 6024",
    d: "M7.153,7.153,5.822,11.644,4.491,7.153,0,5.822,4.491,4.491,5.822,0,7.153,4.491l4.491,1.331L7.153,7.153",
    transform: "translate(776.528 304.499) rotate(-180)",
    fill: "#24dac5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetranscribeIcon);
export default __webpack_public_path__ + "static/media/retranscribeIcon.f01d94424960ed48f58f1b37f8f6ed28.svg";
export { ForwardRef as ReactComponent };